package gr.tech.site.data

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.navigation.UndecoratedLinkVariant
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.site.models.NextEvent
import gr.tech.site.styles.BlogCardHoverStyle
import gr.tech.site.styles.Theme
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*

val NEXT_EVENTS = listOf(
    NextEvent(
        name = "CannaCon Midwest 2026",
        date = "2026-08-09",
        endDate = "2026-08-10",
        description = "CannaCon Midwest 2026. Join us to talk grow operation rebates, LED grow light incentives, and energy efficiency programs. Booth details coming soon.",
        venueName = "Saint Paul RiverCentre",
        city = "St. Paul",
        state = "MN",
        category = "Trade Show",
        url = "https://cannacon.org/midwest/midwest-st-paul-2025/"
    ),
    NextEvent(
        name = "MJBizCon 2026",
        date = "2026-12-01",
        endDate = "2026-12-04",
        description = "MJBizCon 2026. Meet the team and learn how to maximize energy efficiency incentives, HVAC rebates, and cultivation rebates for your facility. Booth details coming soon.",
        venueName = "Las Vegas Convention Center",
        city = "Las Vegas",
        state = "NV",
        category = "Trade Show",
        url = "https://mjbizconference.com/"
    )
)


@Composable
fun NextEventCard(event: NextEvent) {
    val dateDisplay = if (event.endDate.isNotEmpty()) "${event.date} to ${event.endDate}" else event.date
    val locationDisplay = if (event.state.isNotEmpty()) "${event.city}, ${event.state}" else event.city

    @Composable
    fun CardContent() {
        Div(
            attrs = BlogCardHoverStyle.toModifier()
                .classNames("card", "h-100")
                .borderRadius(8.px)
                .cursor(Cursor.Pointer)
                .toAttrs()
        ) {
            // Card body
            Div(attrs = Modifier.classNames("card-body", "d-flex", "flex-column").toAttrs()) {
                H3(
                    attrs = Modifier
                        .classNames("fs-5", "fw-bold", "mb-1")
                        .color(Theme.DarkGreen.rgb)
                        .toAttrs()
                ) { Text(event.name) }

                P(
                    attrs = Modifier
                        .classNames("fs-6", "fw-medium", "mb-1")
                        .color(Theme.MediumGreen.rgb)
                        .toAttrs()
                ) { Text(locationDisplay) }

                P(
                    attrs = Modifier
                        .classNames("fw-light", "mb-2")
                        .color(Colors.Black)
                        .opacity(75.percent)
                        .fontSize(.75.cssRem)
                        .toAttrs()
                ) { Text(dateDisplay) }

                P(
                    attrs = Modifier
                        .classNames("fs-6", "lh-base", "mb-0", "flex-grow-1")
                        .color(Theme.DarkGreen.rgb)
                        .opacity(0.75)
                        .toAttrs()
                ) { Text(event.description) }
            }

            // Card footer
            Div(
                attrs = Modifier
                    .classNames("card-footer", "d-flex", "justify-content-end")
                    .toAttrs()
            ) {
                Span(
                    attrs = Modifier
                        .classNames("fs-6", "text-nowrap")
                        .color(Theme.DarkGreen.rgb)
                        .opacity(0.6)
                        .toAttrs()
                ) { Text(event.venueName) }
            }
        }
    }

    if (event.url.isNotEmpty()) {
        Link(
            path = event.url,
            openExternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB,
            variant = UndecoratedLinkVariant.then(UncoloredLinkVariant),
            modifier = Modifier.fillMaxWidth().textDecorationLine(TextDecorationLine.None)
        ) { CardContent() }
    } else {
        Div(attrs = Modifier.fillMaxWidth().toAttrs()) { CardContent() }
    }
}
